import { formatUSD } from '../../helpers';
import AnalyticsSmallCard from './AnalyticsSmallCard';
// import useAnalytics from '../../hooks/analytics/useAnalytics';
import useMockAnalytics from '../../hooks/analytics/useMockAnalytics';

const ClosedPositions = () => {
    const { analytics, isLoading, defaultData } = useMockAnalytics();

    return (
        <AnalyticsSmallCard
            title='24h Closed Positions'
            percentageDifference={
                analytics
                    ? analytics.dailyClosedPositions.dailyDiffPercentage.toString()
                    : '0'
            }
            amount={formatUSD(
                analytics?.dailyClosedPositions.currentValue.toString() || '0',
                { maxDecimals: 0, currency: '' }
            )}
            data={analytics?.dailyClosedPositions.historicalData ?? defaultData}
            isLoading={isLoading}
            showPercentage
        />
    );
};

export default ClosedPositions;
